/**
 * Правило подмены размеров для одного модификатора.
 *
 * При конвертации заказа размер самого блюда ищется среди ключей equivalentSizes и заменяется
 * значением, поэтому и ключ, и значение — размеры блюда, а не размеры модификатора.
 */
export interface IModifierToSizes {
  equivalentSizes: { [oldSizeId: string]: string };
  isRemove: boolean;
}

export interface ISpecialConvertInstruction {
  modifierToSizes: { [modifierId: string]: IModifierToSizes };
  ignoreModifiers: string[];
}

/** Тело POST. Бэк перезаписывает инструкции целиком, мержа нет. */
export interface ISaveSpecialConvertInstructionRequest {
  organizationId: string;
  specialConvertInstruction: ISpecialConvertInstruction;
}

export const EMPTY_INSTRUCTION: ISpecialConvertInstruction = {
  modifierToSizes: {},
  ignoreModifiers: [],
};
